<template>
<div class="chapter">
<div class="inner_page">
<div><a id="dedi"></a></div><a id="dedi">
<div class="top15">
<p class="centerpica"><img alt="" src="Images/page5.jpg" width="25%"/></p>
<p class="dedication"><span class="txit">For Anna, who would totally gallop to the rescue!</span></p>
</div></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedi.vue?04451ad8